var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStartIsLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117.63784,
    height: 112.1844,
    viewBox: "0 0 117.63784 112.1844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "transform-origin": "50% 50%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 69.742386,41.757335 61.494237,29.002536 c -0.135914,-0.192104 -0.235055,-0.541808 -0.233145,-0.77778 l 0.04174,-6.681448 c 0.0061,-1.30098 -1.046147,-2.363701 -2.347214,-2.369548 -1.301163,-0.0059 -2.370518,1.055159 -2.370327,2.347566 l -0.03553,6.672847 c -0.0018,0.235971 -0.10898,0.579368 -0.223976,0.771853 l -8.406794,12.684649 c -0.121301,0.201087 -0.09924,0.494212 0.04288,0.677714 l 2.104516,2.969286 c 0.148426,0.174996 0.39074,0.16821 0.522834,-0.01166 l 5.657952,-7.793086 c 0.138397,-0.188472 0.26008,-0.138774 0.255877,0.08238 l -0.04814,9.867898 c 0.0044,0.22737 -0.187204,0.416415 -0.414618,0.420812 l -1.020548,-0.0108 c -0.221111,-0.0041 -0.412709,0.184935 -0.414619,0.420907 l -0.01452,1.74317 c 0.0044,0.22737 0.193413,0.4189 0.420827,0.414503 l 7.579276,0.03947 c 0.227415,-0.0044 0.427513,-0.187133 0.429423,-0.423105 l 0.0059,-1.749478 c 0.0019,-0.235972 -0.178512,-0.421194 -0.414523,-0.423105 l -1.011952,-0.0045 c -0.221111,-0.0041 -0.416433,-0.187038 -0.414523,-0.42301 l 0.04193,-9.859391 c 0.0019,-0.235972 0.118435,-0.269041 0.260653,-0.08554 l 5.580015,7.84202 c 0.142122,0.183502 0.378132,0.185318 0.527418,0.01806 l 2.126197,-2.948834 c 0.134482,-0.165056 0.156927,-0.464966 0.02111,-0.65707 z",
    fill: "#ffffff",
    stroke: "#27333e",
    strokeWidth: 1,
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animate6",
    attributeName: "fill",
    attributeType: "XML",
    begin: "animate5.end",
    dur: "1s",
    fill: "freeze",
    from: "#27333e",
    to: "white"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animate1",
    attributeName: "fill",
    attributeType: "XML",
    begin: "0s; animate10.end",
    dur: "1s",
    fill: "freeze",
    from: "white",
    to: "#27333e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 79.158131,65.053544 88.791495,53.00983 c 0.14131,-0.192587 0.446127,-0.400672 0.673891,-0.474879 l 6.443985,-2.114089 c 1.254158,-0.413557 1.939777,-1.768055 1.528542,-3.021124 -0.411236,-1.252973 -1.775012,-1.939135 -3.018895,-1.522381 l -6.433809,2.117383 c -0.227667,0.0743 -0.592478,0.08196 -0.814524,0.03342 L 72.268503,44.034128 c -0.232416,-0.05183 -0.507478,0.06384 -0.638515,0.25972 l -2.18363,2.981019 c -0.120764,0.199173 -0.03664,0.429928 0.178819,0.498999 l 9.313428,2.927931 c 0.225729,0.07237 0.216812,0.205375 0.0027,0.272702 l -9.512987,3.135146 c -0.217491,0.0776 -0.460763,-0.04573 -0.537912,-0.262918 l -0.316544,-0.984824 c -0.06688,-0.213996 -0.310147,-0.337317 -0.537912,-0.263014 l -1.682451,0.548115 c -0.217393,0.0775 -0.341161,0.320945 -0.264013,0.538234 l 2.390363,7.300841 c 0.07715,0.217192 0.317126,0.350782 0.544793,0.276479 l 1.685747,-0.558287 c 0.227764,-0.0743 0.348236,-0.307479 0.274383,-0.535037 l -0.31984,-0.974556 c -0.06697,-0.213995 0.04652,-0.460735 0.274287,-0.535037 l 9.502715,-3.13844 c 0.227667,-0.0743 0.296868,0.02722 0.165831,0.223006 l -5.75982,7.894099 c -0.131037,0.19588 -0.05718,0.423437 0.151682,0.51295 l 3.519297,1.093905 c 0.201983,0.07595 0.497883,9.69e-4 0.639194,-0.191617 z",
    fill: "#ffffff",
    stroke: "#27333e",
    strokeWidth: 1,
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animate7",
    attributeName: "fill",
    attributeType: "XML",
    begin: "animate6.end",
    dur: "1s",
    fill: "freeze",
    from: "#27333e",
    to: "white"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animate2",
    attributeName: "fill",
    attributeType: "XML",
    begin: "1s; animate1.end",
    dur: "1s",
    fill: "freeze",
    from: "white",
    to: "#27333e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 60.440454,80.691741 14.267102,5.422239 c 0.224257,0.07467 0.512617,0.298803 0.651374,0.490967 l 3.940588,5.432893 c 0.768828,1.056708 2.25323,1.29149 3.310418,0.523027 1.057284,-0.768463 1.292195,-2.262865 0.523268,-3.308823 l -3.94049,-5.422239 C 79.05386,83.637642 78.936405,83.296124 78.915102,83.071998 L 78.178227,67.808526 c -0.02139,-0.234782 -0.213606,-0.458909 -0.437864,-0.522931 l -3.470671,-1.15279 c -0.224259,-0.05337 -0.416466,0.09608 -0.416466,0.320209 l 0.05345,9.670378 c 0,0.234782 -0.128203,0.266841 -0.256308,0.08533 L 67.819661,68.19285 c -0.138853,-0.181509 -0.09615,-0.448348 0.0854,-0.587049 l 0.832931,-0.597799 c 0.181556,-0.128045 0.224257,-0.394886 0.08549,-0.587049 l -1.025234,-1.419534 c -0.138854,-0.18151 -0.405813,-0.224223 -0.58737,-0.08542 l -6.161671,4.472268 c -0.181555,0.138795 -0.235005,0.405636 -0.09615,0.597703 l 1.035885,1.419631 c 0.138758,0.192163 0.395066,0.234781 0.587274,0.09608 l 0.822279,-0.597703 c 0.181556,-0.128142 0.448516,-0.09608 0.58737,0.09599 l 5.830705,8.005313 c 0.138855,0.192164 0.0641,0.28815 -0.160157,0.224127 l -9.183918,-3.031336 c -0.224259,-0.06402 -0.416465,0.07477 -0.437865,0.298899 l 0.03206,3.650341 c -0.01065,0.213472 0.149505,0.469658 0.373764,0.544429 z",
    fill: "#ffffff",
    stroke: "#27333e",
    strokeWidth: 1,
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animate8",
    attributeName: "fill",
    attributeType: "XML",
    begin: "animate7.end",
    dur: "1s",
    fill: "freeze",
    from: "#27333e",
    to: "white"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animate3",
    attributeName: "fill",
    attributeType: "XML",
    begin: "2s; animate2.end",
    dur: "1s",
    fill: "freeze",
    from: "white",
    to: "#27333e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 57.183544,80.687183 -14.262815,5.420645 c -0.224192,0.07466 -0.512466,0.298813 -0.651279,0.490824 l -3.939333,5.431297 c -0.768699,1.056397 -2.252569,1.291206 -3.309542,0.522873 -1.056878,-0.768237 -1.291719,-2.262105 -0.523115,-3.307851 l 3.939429,-5.420646 c 0.138717,-0.192107 0.256233,-0.533524 0.27753,-0.757585 l 0.736658,-15.258893 c 0.0213,-0.234808 0.213544,-0.458869 0.437736,-0.522873 l 3.469556,-1.152451 c 0.224192,-0.05335 0.416439,0.09605 0.416439,0.320115 l -0.05343,9.667538 c 0,0.234712 0.128165,0.266762 0.256233,0.0854 l 5.828993,-8.013613 c 0.138813,-0.181455 0.09612,-0.448218 -0.08538,-0.586876 l -0.832782,-0.597624 c -0.181406,-0.128008 -0.224192,-0.39477 -0.08538,-0.586877 l 1.024933,-1.419117 c 0.138717,-0.181456 0.405598,-0.224061 0.587101,-0.0854 l 6.159956,4.470954 c 0.181503,0.138754 0.234841,0.405517 0.09612,0.597624 l -1.035581,1.419117 c -0.138813,0.192107 -0.395047,0.234808 -0.587197,0.09605 l -0.822038,-0.597528 c -0.181502,-0.128103 -0.448384,-0.09605 -0.587101,0.09605 l -5.828993,8.002865 c -0.138813,0.192107 -0.06408,0.288161 0.16011,0.224061 l 9.181225,-3.030437 c 0.224192,-0.064 0.416343,0.07475 0.43764,0.298812 l -0.03204,3.649364 c 0.01075,0.21341 -0.149461,0.469425 -0.373653,0.544176 z",
    fill: "#ffffff",
    stroke: "#27333e",
    strokeWidth: 1,
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animate9",
    attributeName: "fill",
    attributeType: "XML",
    begin: "animate8.end",
    dur: "1s",
    fill: "freeze",
    from: "#27333e",
    to: "white"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animate4",
    attributeName: "fill",
    attributeType: "XML",
    begin: "3s; animate3.end",
    dur: "1s",
    fill: "freeze",
    from: "white",
    to: "#27333e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 38.479718,65.05353 28.84636,53.009824 c -0.141311,-0.192586 -0.446147,-0.400673 -0.673862,-0.474975 l -6.44403,-2.113991 c -1.254118,-0.413557 -1.939788,-1.768054 -1.528536,-3.021122 0.411251,-1.252973 1.775054,-1.939134 3.018918,-1.52238 l 6.433796,2.117382 c 0.227667,0.0743 0.592477,0.08196 0.814523,0.03342 l 14.902173,-3.994031 c 0.232416,-0.05183 0.507478,0.06384 0.638515,0.25972 l 2.183629,2.981017 c 0.120763,0.199173 0.03664,0.429927 -0.17882,0.498999 l -9.313421,2.927929 c -0.22573,0.07237 -0.216813,0.205374 -0.0027,0.272702 l 9.512981,3.135143 c 0.217491,0.0776 0.460763,-0.04572 0.537912,-0.262917 l 0.316543,-0.984824 c 0.06688,-0.213995 0.310147,-0.337317 0.537911,-0.263013 l 1.682451,0.548114 c 0.217393,0.0775 0.341161,0.320944 0.264013,0.538234 l -2.390361,7.300836 c -0.07715,0.217192 -0.317126,0.350782 -0.544793,0.276479 L 46.927456,60.70426 c -0.227764,-0.0743 -0.348236,-0.307479 -0.274383,-0.535038 l 0.31984,-0.974554 c 0.06697,-0.213997 -0.04662,-0.460736 -0.274287,-0.535038 l -9.502722,-3.138436 c -0.227667,-0.0743 -0.296869,0.02722 -0.165831,0.223004 l 5.759816,7.894096 c 0.131036,0.195879 0.05718,0.423437 -0.151682,0.512948 l -3.519295,1.093905 c -0.201983,0.07595 -0.497883,9.69e-4 -0.639194,-0.191617 z",
    fill: "#ffffff",
    stroke: "#27333e",
    strokeWidth: 1,
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animate10",
    attributeName: "fill",
    attributeType: "XML",
    begin: "animate9.end",
    dur: "1s",
    fill: "freeze",
    from: "#27333e",
    to: "white"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animate5",
    attributeName: "fill",
    attributeType: "XML",
    begin: "4s; animate4.end",
    dur: "1s",
    fill: "freeze",
    from: "white",
    to: "#27333e"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartIsLoading);
export default __webpack_public_path__ + "static/media/start-is-loading.88cba2bd.svg";
export { ForwardRef as ReactComponent };